// extracted by mini-css-extract-plugin
export var backdropBlur = "_ii-0";
export var contentCard = "_ii-5";
export var frame = "_ii-2";
export var image = "_ii-4";
export var imagePane = "_ii-3";
export var modal = "_ii-1";